import(/* webpackMode: "eager" */ "/codebuild/output/src2453106473/src/client-hcap/app/additional-hcap-resources/methodological-information/page.tsx");
